module.exports = __webpack_public_path__ + "img/emd00.988582f7.png";